import { useRouter } from "next/router";
import en from "./en.json";
import ar from "./ar.json";

export type Locale = "en" | "ar";

export const dictionaries = { en, ar } as const;

export type Dictionary = typeof en;

export function getDictionary(locale: string | undefined): Dictionary {
  if (locale === "ar") return ar as Dictionary;
  return en;
}

export function isRtl(locale: string | undefined): boolean {
  return locale === "ar";
}

export function useTranslation() {
  const { locale } = useRouter();
  const t = getDictionary(locale);
  return { t, locale: (locale ?? "en") as Locale, isRtl: isRtl(locale) };
}
